import React from 'react';
import './Hamburger.scss';

const Hamburger = ({ onClick }) => (
  <button onClick={onClick} className="hamburger">
    <img src={require('../../images/hamburger.svg')} alt="Hamburger" />
  </button>
);

export default Hamburger;
